export const TestStatuses = [
	{ label: 'Echoué',  value: 'failed',   color: '#FF3D62' },
	{ label: 'Terminé', value: 'finished', color: '#8BEA67' },
	{ label: 'Dérogation',value: 'exemption',  color: '#FFA907' },
	{ label: 'En cours',value: 'pending',  color: '#FFFFFF' },
	{ label: 'À valider',value: 'to_validate',  color: '#039BE5' },
]



// WEBPACK FOOTER //
// ./src/config/enum/TestStatuses.js